import { combineReducers, createStore, applyMiddleware, compose } from 'redux'
import { reducer as reduxFormReducer } from 'redux-form'
import reduxThunk from 'redux-thunk'
import {
  sidebarReducer,
  themeReducer,
  newOrderTableReducer,
  userReducer,
  productReducers,
  cartReducer,
  complianceReducer,
  stripeReducer,
  profileActivityReducer,
  apolloReducer,
  toggleTourReducer
} from '../redux/reducers/index'
// import logger from 'redux-logger'

const reducer = combineReducers({
  form: reduxFormReducer, // mounted under "form",
  theme: themeReducer,
  sidebar: sidebarReducer,
  newOrder: newOrderTableReducer,
  auth: userReducer,
  productsData: productReducers,
  cartData: cartReducer,
  controlsData: complianceReducer,
  stripeData: stripeReducer,
  profileActivity: profileActivityReducer,
  apollo: apolloReducer,
  toggleTour: toggleTourReducer
})

const store = createStore(reducer,
  { controlsData: { loading: true } },
  compose(
    applyMiddleware(reduxThunk),
    // applyMiddleware(logger),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
  ))

export default store



// WEBPACK FOOTER //
// ./src/app/store.js